import { forwardRef, useId, type InputHTMLAttributes } from 'react';
import { cn } from '@/shared/helpers/cn';
import styles from './Checkbox.module.scss';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
  hint?: string;
}

/** Caixa de selecao com rotulo clicavel e alvo de toque adequado. */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, hint, className, id: providedId, ...rest },
  ref,
) {
  const generatedId = useId();
  const id = providedId ?? generatedId;
  const hintId = `${id}-hint`;

  return (
    <div className={cn(styles.root, className)}>
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className={styles.input}
        aria-describedby={hint ? hintId : undefined}
        {...rest}
      />
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      {hint ? (
        <p className={styles.hint} id={hintId}>
          {hint}
        </p>
      ) : null}
    </div>
  );
});
